import React from "react";
import Table from "react-bootstrap/Table";
import '../../pages/AutomatedDailyReportPage/AutomatedDailyReport.scss';

export default function MonthlyOnlyFilteredHeader(props) {

    const {
        currentMonthliesIn,
        spaces, 
        utilization, 
        garageName
    } = props;

    const totalSpaces = Number.isFinite(Number(spaces)) ? Number(spaces) : 0;
    const currentIn = Number.isFinite(Number(currentMonthliesIn)) ? Number(currentMonthliesIn) : 0;
    const freeSpaces = Math.max(totalSpaces - currentIn, 0);
    const utilizationValue = Number.isFinite(Number(utilization))
        ? Number(utilization).toFixed(2)
        : "0.00";

    return (
        <>
        <h5 className="d-flex justify-content-center">{garageName} Filtered Report Page</h5>
        <Table striped bordered className="table-sm header-mobile">
            <thead>
                <tr className="table-warning">
                    <th>Total Spaces</th>
                    <th>Current M In</th>
                    <th>Free Spaces</th>
                    <th>Reserved for Monthlies</th>
                    <th>Garage Utilization</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{totalSpaces}</td>
                    <td>{currentIn}</td>
                    <td>{freeSpaces}</td>
                    <td>0</td>
                    <td>{utilizationValue}%</td>
                </tr>
            </tbody>
        </Table>
        </>
    );
}
